import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const ArrowUp = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.872 11.979a.874.874 0 0 0 .262-.62.863.863 0 0 0-.262-.619L13.53 5.49a.891.891 0 0 0-.63-.257.904.904 0 0 0-.63.257l-5.342 5.25a.868.868 0 0 0 0 1.239.9.9 0 0 0 1.26 0L12.9 7.347l4.711 4.632a.892.892 0 0 0 .63.257.904.904 0 0 0 .631-.257Z"
      fill={color}
    />
    <Path
      d="M13.53 18.977a.898.898 0 0 1-1.259 0 .868.868 0 0 1-.26-.618V6.985c0-.232.093-.455.26-.619a.899.899 0 0 1 1.26 0c.166.164.26.387.26.619v11.374a.867.867 0 0 1-.26.618Z"
      fill={color}
    />
  </Svg>
);

export default ArrowUp;
